<template>
  <div class="contact-page container mx-auto">
    <h1 class="title text-center text-darker-grey mb-12 xxl:mb-24">
      Contact Us
    </h1>
    <form
      class="contact-form flex flex-col items-stretch"
      @submit.prevent="onSubmit"
    >
      <div class="grid mb-8 lg:mb-12 w-full">
        <input-component
          v-for="(field, name) in form"
          :key="name"
          :name="name"
          :label="field.label"
          v-model="form[name].value"
          @validate="validate"
          @blur="form[name].blurred = true"
          :error="error(name)"
          :inputmode="field.inputmode"
          :isSelect="name === 'country_code'"
          :selectOptions="countries"
        ></input-component>
      </div>
      <privacy-consent
        class="mb-8 lg:mb-12 pl-1 md:pl-0 justify-center"
        v-bind:checked.sync="privacyConsent"
      ></privacy-consent>
      <div class="btn-container flex justify-center">
        <button
          class="btn btn-primary m-5 flex justify-center items-center"
          :class="{ disabled: formIsInvalid || loading }"
        >
          <span v-if="loading" class="spinner"></span>
          <span v-else>Send</span>
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from 'vuex';
import {GETTERS} from '../../store/wizard/types';
import InputComponent from "./forms/InputComponent";
import PrivacyConsent from './PrivacyConsent.vue';
import countriesArray from '../../countries';


export default {
  components: {
    InputComponent,
    PrivacyConsent,
  },

  data() {
    return {
      countries: countriesArray,
      form: {
        first_name: {
          value: "",
          label: "Name*",
          validateOnBlur: false,
          blurred: false,
          inputmode: 'text',
        },
        last_name: {
          value: "",
          label: "Last Name*",
          validateOnBlur: false,
          blurred: false,
          inputmode: 'text',
        },
        company: {
          value: "",
          label: "Company name*",
          validateOnBlur: false,
          blurred: false,
          inputmode: 'text',
        },
        country_code: {
          value: "",
          label: "Country*",
          validateOnBlur: true,
          blurred: false,
          inputmode: 'slect',
        },
        email: {
          value: "",
          label: "Email*",
          validateOnBlur: true,
          blurred: false,
          inputmode: 'email',
        },
        // phone: {
        //   value: "",
        //   label: "Phone number",
        //   validateOnBlur: false,
        //   blurred: false,
        //   inputmode: 'tel',
        // },
      },
      errors: {
        name: "",
        company: "",
        email: "",
        // phone: "",
      },
      privacyConsent: false,
      loading: false,
      toastError: null,
    };
  },

  computed: {
    formIsInvalid() {
      for (let fieldName in this.form) {
        const field = this.form[fieldName];
        const fieldError = this.errors[fieldName];
        
        if (!field.value || fieldError) {
          return true;
        }
      }
      
      return !this.privacyConsent;
    },
    ...mapGetters({
        consultId: GETTERS.GET_CONSULT_ID
    }),
  },

  methods: {
    validate({ name, value, fromInputEvent }) {
      const { valid, message, empty } = this.validateField(name, value);

      if (!valid) {
        if (
          this.form[name].validateOnBlur &&
          fromInputEvent &&
          !this.form[name].blurred &&
          !empty
        ) {
          return;
        }

        this.errors = { ...this.errors, [name]: message };
      } else {
        this.$delete(this.errors, name);
      }
    },

    error(name) {
      if (Object.keys(this.errors).includes(name)) {
        return this.errors[name];
      }

      return "";
    },

    validateField(name, value) {
      switch (name) {
        case "email":
          if (value && !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(value)) {
            return {
              valid: false,
              message: "Please enter a valid email.",
              empty: false,
            };
          } else if(!value){
            return {
              valid: false,
              message: "This field is required.",
              empty: true,
            };
          }
        case "country_code":
          if (!value) {
            return {
              valid: false,
              message: "Please select a country.",
              empty: true,
            };
          }
        default:
          if (!value) {
            return {
              valid: false,
              message: "This field is required.",
              empty: true,
            };
          }
      }

      return { valid: true, message: "" };
    },

    onSubmit() {
      const formData = {};

      for (let field in this.form) {
        formData[field] = this.form[field].value;
      }

      if (this.formIsInvalid) return;

      if (this.toastError) {
        this.toastError.dismiss();
      }

      this.loading = true;

      axios
        .post("/api/send-contact-email", {
            contact: formData,
            consult_id: this.consultId,
        })
        .then(() => {
          // Send a message to the parent page for redirection
          window.parent.postMessage('emailSentAction.talk_to_engineer', '*');
          // this.$router.replace('/email-sent?contact')
        })
        .catch(() => {
          this.loading = false;
          this.toastError = this.$toast.error('Something went wrong. Please try again.');
        });
    },
  },

  beforeRouteEnter (to, from, next) {
    if (from.name !== 'resume') {
        return next({ name: 'applications' });
    }
    next();
  }
};
</script>
